import React from 'react';
import chroma from 'chroma-js';
import { Card, Badge, Col, ListGroup } from '../../../ui-kit';
import { IconTruckFront } from '../../../ui-kit/icons';
import { themeType } from '../../../ui-kit/helpers';
import TeamMember from './TeamMember';
import AvailabilityIcon from '../../../general/AvailabilityIcon';

const TeamPanel = ({ team, parentGroup, showParentGroup, availableMembers, available, taskAvailability }) => {
  const customColorPanelHeader = {
    backgroundColor: chroma(team.color || 'white')
      .alpha(0.25)
      .css()
  };

  const members = availableMembers.filter(m => m.groupId === team.id);
  const groupScheduleLink = `/groups/${team.id}/schedule/group_schedule`;
  const showAvailabilityIcon = team.type === 'team';
  // If there is no parent group, display nothing, otherwise choose short code or name
  const parentGroupName = parentGroup && (parentGroup.short_code || parentGroup.name);

  const dutyMembers = members.filter(m => m.assignedFunctions.length > 0);
  const onCallMembers = members.filter(m => m.assignedFunctions.length === 0);

  return (
    <Col>
      <Card>
        <Card.Header style={customColorPanelHeader}>
          <Card.Title>
            <h5>
              {showAvailabilityIcon && <AvailabilityIcon available={available} />}{' '}
              <a href={groupScheduleLink} style={{ color: 'var(--bs-body-color)' }}>
                {team.name} {showParentGroup && <small>{team.type === 'team' && parentGroupName}</small>}
              </a>
            </h5>
            {team.tasks.length > 0 && (
              <>
                <hr className="my-2" /> <IconTruckFront className="me-2" />
                {team.tasks.map(
                  task =>
                    (taskAvailability[task.id] || {}).available && (
                      <Badge pill={true} key={task.id} className="me-1">
                        {task.name}
                      </Badge>
                    )
                )}
              </>
            )}
          </Card.Title>
        </Card.Header>
        <ListGroup variant="flush">
          {dutyMembers.length > 0 && (
            <>
              <ListGroup.Item className="py-1 text-dark" style={{ background: 'var(--bs-info)' }}>
                <small>
                  {dutyMembers.length} {I18n.t('availability_status.standby_duty.available').toUpperCase()}
                </small>
              </ListGroup.Item>
              {dutyMembers.map(m => (
                <TeamMember member={m} key={m.ownerId} groupId={team.id} />
              ))}
            </>
          )}
          {onCallMembers.length > 0 && (
            <>
              <ListGroup.Item
                className="py-1"
                style={{
                  background: themeType === 'light' ? 'var(--bs-gray-400)' : 'var(--bs-gray-800)'
                }}
              >
                <small>
                  {onCallMembers.length} {I18n.t('available').toUpperCase()}
                </small>
              </ListGroup.Item>
              {onCallMembers.map(m => (
                <TeamMember member={m} key={m.ownerId} groupId={team.id} />
              ))}
            </>
          )}
          {members.length === 0 && (
            <ListGroup.Item>
              <i>{I18n.t('nobody_available')}</i>
            </ListGroup.Item>
          )}
        </ListGroup>
      </Card>
    </Col>
  );
};

export default TeamPanel;
